module.exports = __webpack_public_path__ + "static/media/998029.b1da0915.jpg";